type RedirectedRef = {
  current: boolean
}

export const handleDeferredRedirectClose = (
  redirectUrl: string,
  hasRedirectedRef: RedirectedRef,
  clearDeferredRedirect: () => void,
  redirect: (url: string) => void
) => {
  if (hasRedirectedRef.current) {
    return
  }

  hasRedirectedRef.current = true
  clearDeferredRedirect()
  redirect(redirectUrl)
}
